import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import LoadingSpinner from '../components/common/LoadingSpinner';
import PageContentBlocks from '../components/common/PageContentBlocks';
import usePageContent from '../hooks/usePageContent';
import { storiesAPI } from '../services/api';

export default function StoriesPage() {
  const { t, i18n } = useTranslation();
  const { blocks } = usePageContent('stories', i18n.language);
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    storiesAPI.getAll({ language: i18n.language }).then((res) => setStories(res.data.data)).finally(() => setLoading(false));
  }, [i18n.language]);

  return (
    <>
      <SEO title={t('stories.title')} description={t('stories.subtitle')} />
      <section className="py-12 px-4 max-w-5xl mx-auto">
        <h1 className="section-title mb-2">{t('stories.title')}</h1>
        <p className="text-gray-500 mb-6">{t('stories.subtitle')}</p>
        <PageContentBlocks blocks={blocks} className="mb-10" />
        {loading ? <LoadingSpinner className="py-20" /> : (
          <div className="grid md:grid-cols-2 gap-6">
            {stories.map((story, i) => (
              <motion.div key={story.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} className="card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-brand-400 to-gold-400 flex items-center justify-center text-xl">⭐</div>
                  <div>
                    <h3 className="font-bold">{story.title}</h3>
                    <p className="text-sm text-brand-600">— {story.authorName}</p>
                  </div>
                </div>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed italic">"{story.story}"</p>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
